import React, { useMemo } from "react";
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import { ColumnStartOrder, ColumnBib, ColumnResult, ColumnNoc, ColumnTeamComponents, ColumnRank } from "components/common/TableColumns"
import MirsTable from "components/general/table/Table";
import { CATEGORY } from 'components/sports/ath/helper/AthHelpers'
import SportCode from 'components/common/SportCode'
import { getRscObject } from 'helpers/rsc';
import { findArray, RscFromStore } from 'helpers/utils'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

export function ColumnResultHJumps({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderResult'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'sortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Result',

            Cell: (props) => {
                let rsc = RscFromStore()
                let discipline = getRscObject(rsc).discipline
                let rowNumberIrm = findArray(props.cell.row.original.extendedResults, { er_code: ['IRM_LAP'] })
                let numberIrm = rowNumberIrm?.er_value || ''
                let resultIrm = (props.cell.row.original.resultIrm)

                let irmObject = {}
                switch (resultIrm) {
                    case 'DNF':
                        irmObject = <><SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} />{numberIrm}</>
                        break;
                    case 'LAP':
                        irmObject = <>{numberIrm}<SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} /></>
                        break;
                    default:
                        irmObject = <SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} />
                        break;
                }

                const row = props.cell.row.original
                let num = findArray(row?.extendedResults, { er_code: ['INTERMEDIATE'], er_value: [props.cell.row.original.resultData] })
                let wind = findArray(num?.extensions, { ere_code: ['WIND_SPEED'] })

                return (
                    props.cell.row.original.resultType === 'IRM'
                        ? irmObject
                        : props.cell.row.original.resultType === 'TIME' && props.cell.row.original.unchecked === 'Y'
                            ? `(${props.cell.row.original.resultData})`
                            : <div>
                                <div>{props.cell.row.original.resultData}</div>
                                <div>{wind.ere_value}</div>
                            </div>
                )
            },
        }
    )
}

export function getColumns(type) {
    const arrVJumps = [
        ColumnStartOrder({ disableSort: true, label: "HeaderOrder" }),
        ColumnBib({ disableSort: true, label: 'HeaderBibNoR', headerClassName : 'text-end w-5'}),
        ColumnNoc({ disableSort: true, label: "" }),
        ColumnTeamComponents({ disableSort: true }),
        {
            Header: <Label data='HeaderAttempt' />,
            id: 'CurrentData3',
            accessor: 'heightAttempt',
            className: 'text-end',
            headerClassName: 'text-end'

        },
        {
            Header: <Label data='HeaderResult' />,
            id: 'CurrentData4',
            accessor: 'participant.code',
            className: 'text-end',
            headerClassName: 'text-end',
            Cell: (props) => {
                const row = props.cell.row.original
                let num = findArray(row?.extendedResults, { er_pos: [row.pos], er_code: ['INTERMEDIATE'] })
                return (num?.er_value)
            }
        },
        ColumnResult({ label: "HeaderBest" }),
        ColumnRank({ disableSort: true }),
    ]
    const arrHJumps = [
        ColumnStartOrder({ disableSort: true, label: "HeaderOrder" }),
        ColumnBib({ disableSort: true, label: 'HeaderBibNoR', headerClassName : 'text-end w-5'}),
        ColumnNoc({ disableSort: true, label: "" }),
        ColumnTeamComponents({ disableSort: true }),
        {
            Header: <Label data='HeaderAttempt' />,
            id: 'CurrentData3',
            accessor: 'pos',
            className: 'text-end',
            headerClassName: 'text-end'

        },
        {
            Header: <Label data='HeaderResult' />,
            id: 'CurrentData4',
            accessor: 'participant.code',
            className: 'text-end',
            headerClassName: 'text-end',
            Cell: (props) => {
                const row = props.cell.row.original
                let num = findArray(row?.extendedResults, { er_pos: [row.pos], er_code: ['INTERMEDIATE'] })
                let wind = findArray(num?.extensions, { ere_code: ['WIND_SPEED'] })
                return (<div>
                    <div>{num?.er_value}</div>
                    <div>{wind.ere_value}</div>
                </div>)
            }
        },
        ColumnResultHJumps({ label: "HeaderBest" }),
        ColumnRank({ disableSort: true }),
    ]
    const arrThrows = [
        ColumnStartOrder({ disableSort: true, label: "HeaderOrder" }),
        ColumnBib({ disableSort: true, label: 'HeaderBibNoR', headerClassName : 'text-end w-5'}),
        ColumnNoc({ disableSort: true, label: "" }),
        ColumnTeamComponents({ disableSort: true }),
        {
            Header: <Label data='HeaderAttempt' />,
            id: 'CurrentData3',
            accessor: 'pos',
            className: 'text-end',
            headerClassName: 'text-end'

        },
        {
            Header: <Label data='HeaderResult' />,
            id: 'CurrentData4',
            accessor: 'participant.code',
            className: 'text-end',
            headerClassName: 'text-end',
            Cell: (props) => {
                const row = props.cell.row.original
                let num = findArray(row?.extendedResults, { er_pos: [row.pos], er_code: ['INTERMEDIATE'] })
                return (num?.er_value)
            }
        },
        ColumnResult({ label: "HeaderBest" }),
        ColumnRank({ disableSort: true }),
    ]
    let arr
    switch (type) {
        case CATEGORY.VJUMPS:
            arr = arrVJumps
            break
        case CATEGORY.HJUMPS:
            arr = arrHJumps
            break
        case CATEGORY.THROWS:
            arr = arrThrows
            break
        default:
            arr = arrThrows
            break
    };
    return (
        arr
    )
}

export function getColumnsXS(type) {
    const arrVJumps = [
        ColumnNoc({ disableSort: true, label: "" }),
        ColumnTeamComponents({ disableSort: true }),
        {
            Header: <Label data='HeaderAttempt' />,
            id: 'CurrentData3',
            accessor: 'heightAttempt',
            className: 'text-end',
            headerClassName: 'text-end'

        },
        {
            Header: <Label data='HeaderResult' />,
            id: 'CurrentData4',
            accessor: 'participant.code',
            className: 'text-end',
            headerClassName: 'text-end',
            Cell: (props) => {
                const row = props.cell.row.original
                let num = findArray(row?.extendedResults, { er_pos: [row.pos], er_code: ['INTERMEDIATE'] })
                return (num?.er_value)
            }
        },
        ColumnResult({ label: "HeaderBest" }),
        ColumnRank({ disableSort: true }),
    ]
    const arrHJumps = [
        ColumnNoc({ disableSort: true, label: "" }),
        ColumnTeamComponents({ disableSort: true }),
        {
            Header: <Label data='HeaderAttempt' />,
            id: 'CurrentData3',
            accessor: 'pos',
            className: 'text-end',
            headerClassName: 'text-end'

        },
        {
            Header: <Label data='HeaderResult' />,
            id: 'CurrentData4',
            accessor: 'participant.code',
            className: 'text-end',
            headerClassName: 'text-end',
            Cell: (props) => {
                const row = props.cell.row.original
                let num = findArray(row?.extendedResults, { er_pos: [row.pos], er_code: ['INTERMEDIATE'] })
                let wind = findArray(num?.extensions, { ere_code: ['WIND_SPEED'] })
                return (<div>
                    <div>{num?.er_value}</div>
                    <div>{wind.ere_value}</div>
                </div>)
            }
        },
        ColumnResult({ label: "HeaderBest" }),
        ColumnRank({ disableSort: true }),
    ]
    const arrThrows = [
        ColumnStartOrder({ disableSort: true, label: "HeaderOrder" }),
        ColumnBib({ disableSort: true }),
        ColumnNoc({ disableSort: true, label: "" }),
        ColumnTeamComponents({ disableSort: true }),
        {
            Header: <Label data='HeaderAttempt' />,
            id: 'CurrentData3',
            accessor: 'pos',
            className: 'text-end',
            headerClassName: 'text-end'

        },
        {
            Header: <Label data='HeaderResult' />,
            id: 'CurrentData4',
            accessor: 'participant.code',
            className: 'text-end',
            headerClassName: 'text-end',
            Cell: (props) => {
                const row = props.cell.row.original
                let num = findArray(row?.extendedResults, { er_pos: [row.pos], er_code: ['INTERMEDIATE'] })
                return (num?.er_value)
            }
        },
        ColumnResult({ label: "HeaderBest" }),
        ColumnRank({ disableSort: true }),
    ]
    let arr
    switch (type) {
        case CATEGORY.VJUMPS:
            arr = arrVJumps
            break
        case CATEGORY.HJUMPS:
            arr = arrHJumps
            break
        case CATEGORY.THROWS:
            arr = arrThrows
            break
        default:
            arr = arrThrows
            break
    };
    return (
        arr
    )
}

const PreviousCompetitor = ({ data, type, isOneGroup }) => {

    const { mirs_rsc } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    let columns
    if (breakPoint === "xxl" || breakPoint === "xl" || breakPoint === "lg") {
        columns = getColumns(type)
    } else {
        columns = getColumnsXS(type)
    }
    const configPrevious = useMemo(() => columns, [data.currentSplit, breakPoint]);

    let hiddenColumns = []
    if(!isOneGroup) hiddenColumns.push('StartOrder', 'Bib')

    return (
        <div className="mirs-page-container-previous">
            < MirsTable
                className='table-result'
                data={[data]}
                columns={configPrevious}
                keyRow='participant-code'
                caption={<Label data='HeaderPreviousCompetitor' />}
                hiddenColumns={hiddenColumns}
                id={`mirs-table-result-${mirs_rsc}`}
            />
        </div>
    );
}

export default PreviousCompetitor;